import React, { useEffect } from "react";
import { Modal, Text, TouchableOpacity, View } from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import Ionicons from "@expo/vector-icons/Ionicons";
import { useNotificationDetailsPopupStyles } from "../Notifications/NotificationPopup/notificationDetailsPopupStyles";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

export function ChallengeActionPopup(props) {
  const {
    showModal = false,
    setShowModal,
    onClose,
    onExploreKallout,
    action = "reject",
    autoRedirectToHome = false,
    redirectDelay = 3000,
  } = props;

  const styles = useNotificationDetailsPopupStyles();
  const deviceSize = useDeviceSize();
  const isMobile = deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;

  const getPopupContent = () => {
    switch (action) {
      case "accept":
        return {
          title: "Challenge Accepted",
          message: "Great choice! You're ready to compete and earn rewards.",
          description:
            "Prepare for battle and show your skills on the battlefield!",
          buttonText: "Get Ready",
        };
      case "reject":
        return {
          title: "Challenge Rejected",
          message: "We have plenty of other exciting fights",
          description:
            "It's a shame you missed this one! But don't worry, there are plenty of other exciting fights on Kallout just waiting for you.",
          buttonText: "Explore Kallout",
        };
      case "negotiate":
        return {
          title: "Negotiation Started",
          message: "Time to discuss the terms",
          description:
            "You can now chat with the organizer to negotiate challenge terms and conditions.",
          buttonText: "Open Chat",
        };
      default:
        return {
          title: "Action Completed",
          message: "Your action has been processed",
          description: "Continue exploring exciting challenges on Kallout.",
          buttonText: "Continue",
        };
    }
  };

  const content = getPopupContent();

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setShowModal(false);
  };

  const handleActionButton = () => {
    if (onExploreKallout) {
      onExploreKallout();
    }
    handleClose();
  };

  // Auto-redirect functionality
  useEffect(() => {
    if (autoRedirectToHome && showModal) {
      const timer = setTimeout(() => {
        handleActionButton();
      }, redirectDelay);

      return () => clearTimeout(timer);
    }
  }, [autoRedirectToHome, showModal, redirectDelay]);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={handleClose}
    >
      <View style={styles.container}>
        <View style={[styles.mainView, { maxWidth: 700, minHeight: "auto" }]}>
          {/* Header */}
          <View style={styles.header}>
            <Text
              style={[
                isMobile ? AppFontStyle.BOLD_ANYBODY_16 : AppFontStyle.BOLD_ANYBODY_24,
                {
                  color: AppColors.white,
                  flex: 1,
                },
              ]}
            >
              {content.title}
            </Text>
            <TouchableOpacity onPress={handleClose}>
              <View style={styles.closeIconWrapper}>
                <Ionicons name="close" size={20} color={AppColors.white} />
              </View>
            </TouchableOpacity>
          </View>

          <View style={styles.separator} />

          {/* Content */}
          <View
            style={{
              alignItems: "center",
              paddingVertical: 40,
              paddingHorizontal: 20,
            }}
          >
            {/* Main Message */}
            <Text
              style={[
                isMobile ? AppFontStyle.BOLD_ANYBODY_16 : AppFontStyle.BOLD_ANYBODY_28,
                {
                  color: AppColors.white,
                  textAlign: "center",
                  marginBottom: isMobile ? 16 : 24,
                },
              ]}
            >
              {content.message}
            </Text>

            {/* Description */}
            <Text
              style={[
                isMobile ? AppFontStyle.REGULAR_ANYBODY_14 : AppFontStyle.REGULAR_ANYBODY_16,
                {
                  color: AppColors.white,
                  textAlign: "center",
                  lineHeight: isMobile ? 20 : 24,
                  marginBottom: isMobile ? 20 : 32,
                },
              ]}
            >
              {content.description}
            </Text>

            {action === "reject" && (
              <View
                style={{
                  marginBottom: 32,
                  alignSelf: "flex-start",
                  width: "100%",
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginBottom: 12,
                  }}
                >
                  <View
                    style={{
                      width: 6,
                      height: 6,
                      borderRadius: 3,
                      backgroundColor: AppColors.white,
                      marginRight: 12,
                    }}
                  />
                  <Text
                    style={[
                      isMobile ? AppFontStyle.REGULAR_ANYBODY_14 : AppFontStyle.REGULAR_ANYBODY_16,
                      { color: AppColors.white },
                    ]}
                  >
                    Earn KO coins/wagers by playing & winning
                  </Text>
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <View
                    style={{
                      width: 6,
                      height: 6,
                      borderRadius: 3,
                      backgroundColor: AppColors.white,
                      marginRight: 12,
                    }}
                  />
                  <Text
                    style={[
                      isMobile ? AppFontStyle.REGULAR_ANYBODY_14 : AppFontStyle.REGULAR_ANYBODY_16,
                      { color: AppColors.white },
                    ]}
                  >
                    Watch live events & battles
                  </Text>
                </View>
              </View>
            )}

            {/* Action Button */}
            <TouchableOpacity
              style={[
                styles.acceptRejectButtonStyle,
                {
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  width: "100%",
                  marginBottom: 0,
                },
              ]}
              onPress={handleActionButton}
            >
              <Text
                style={[
                  styles.buttonText,
                  {
                    color: AppColors.white,
                  },
                ]}
              >
                {content.buttonText}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
}

export default ChallengeActionPopup;
